<template>
  <div class="user-edit">
    <el-form
      class="zwx-form edit-form"
      style="padding: 0 !important;"
      key="mainForm"
      ref="mainForm"
      :model="mainForm"
      :rules="rules"
      label-position="right"
    >
      <!-- 基础信息部分 -->
      <base-headline title="基本信息" class="headline no-top" />
      <div style="max-width: 544px; padding: 10px 0 5px 20px !important;">
        <el-form-item label-width="82px" label="地区：" required>
          <zwx-select-area
            ref="areaSelect"
            @change="areaSelectChange()"
            @loadOver="areaSelectLoadOver()"
            :zoneCode12From="zoneCode12From"
            zoneTypeMax="0"
            zoneTypeMin="4"
            :showFullName="false"
            :disabled="false"
            :clearable="false"
          />
        </el-form-item>
        <el-form-item
          label-width="82px"
          label="机构名称："
          prop="fkByUnitId.rid"
        >
          <el-select
            class="zwx-select"
            popper-class="zwx-select-popper"
            v-model="mainForm.fkByUnitId.rid"
            @change="unitChange"
            placeholder="请选择"
            :filterable="true"
            :clearable="true"
          >
            <el-option
              v-for="item in unitList"
              :key="item.rid"
              :label="item.unitName"
              :value="item.rid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="82px" label="用户账号：" prop="userNo">
          <el-input
            class="zwx-input"
            v-model.trim="mainForm.userNo"
            @input="
              $validate.capitalizationNumbers($data['mainForm'], 'userNo')
            "
            maxlength="30"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label-width="82px" label="用户姓名：" prop="userName">
          <el-input
            class="zwx-input"
            v-model.trim="mainForm.userName"
            maxlength="100"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label-width="82px" label="组织架构：">
          <custom-multiple
            ref="userOrganIdRef"
            v-model="mainForm.organIdList"
            speed="rid"
            value="organName"
            :clearable="true"
            :collapseTags="true"
            :disabled="false"
          />
        </el-form-item>
        <el-form-item label-width="82px" label="曾用名：">
          <el-input
            class="zwx-input"
            v-model.trim="mainForm.usedName"
            maxlength="100"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label-width="82px" label="性别：">
          <code-radio
            :codeType="userSexCodeTypeCode"
            v-model="mainForm.userSex"
          />
        </el-form-item>
        <el-form-item label-width="82px" label="手机号码：" prop="mobileTel">
          <el-input
            class="zwx-input"
            v-model.trim="mainForm.mobileTel"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label-width="82px" label="身份证号：" prop="idc">
          <el-input
            class="zwx-input"
            v-model.trim="mainForm.idc"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label-width="82px" label="民族：">
          <code-select
            :codeType="userNationCodeTypeCode"
            v-model="mainForm.userNation"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item label-width="82px" label="学历：">
          <code-select
            :codeType="educationCodeTypeCode"
            v-model="mainForm.education"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item label-width="82px" label="学位：">
          <code-select
            :codeType="degreeCodeTypeCode"
            v-model="mainForm.degree"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item label-width="82px" label="婚姻状况：">
          <code-select
            :codeType="maritalStatusCodeTypeCode"
            v-model="mainForm.maritalStatus"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item label-width="82px" label="政治面貌：">
          <code-select
            :codeType="politicalLandscapeCodeTypeCode"
            v-model="mainForm.politicalLandscape"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item label-width="82px" label="宗教信仰：">
          <code-select
            :codeType="religionCodeTypeCode"
            v-model="mainForm.religion"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item label-width="82px" label="职位：">
          <el-input
            class="zwx-input"
            v-model.trim="mainForm.position"
            maxlength="30"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label-width="82px" label="职称：">
          <el-input
            class="zwx-input"
            v-model.trim="mainForm.jobTitle"
            maxlength="30"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label-width="82px" label="状态：" required>
          <el-radio-group class="zwx-radio-group" v-model="mainForm.ifEnable">
            <el-radio class="zwx-radio" :label="true">启用</el-radio>
            <el-radio class="zwx-radio" :label="false">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label-width="82px" label="技术职务：">
          <el-input
            class="zwx-input"
            v-model.trim="mainForm.technicalPosition"
            maxlength="50"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label-width="82px" label="专业：">
          <el-input
            class="zwx-input"
            v-model.trim="mainForm.major"
            maxlength="50"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label-width="82px" label="分工：">
          <el-input
            class="zwx-input"
            v-model.trim="mainForm.workDivision"
            maxlength="50"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label-width="82px" label="签名：">
          <file-upload
            v-show="mainForm.fileList && mainForm.fileList.length == 0"
            ref="fileUploadRef"
            @showFileList="clickPositive"
            @success="clickPositiveSuccess"
            @error="clickError()"
            :size="5 * 1024 * 1024"
            sizeInfo="5M"
            accept=".jpg,.jpeg,.JPG,.JPEG,.png,.PNG"
          >
            <div class="container">
              <el-button class="zwx-button zwx-button-28">
                <span class="btnstyle">
                  上传
                </span>
              </el-button>
            </div>
          </file-upload>
          <div
            v-if="mainForm.fileList && mainForm.fileList.length > 0"
            style="margin-left: 12px;"
          >
            <div
              v-for="(item, index) in mainForm.fileList"
              :key="item.fileName"
              @mouseenter="mouseenter(index)"
              @mouseleave="mouseleave(index)"
              style="line-height: 32px;width: fit-content;"
            >
              <span>
                <i
                  :class="item.fileIconShow"
                  style="color:#316CF5! important"
                />
                <a
                  style="color:#194DFF !important;cursor:pointer;"
                  @click="openFilePreview(mainForm.fileList, index)"
                >
                  {{ mainForm.userName }}
                </a>
                <span
                  style="position:relative;top:2px;"
                  class="el-upload-list__item check"
                  :style="
                    item.check
                      ? 'margin-left:5px;display:none;'
                      : 'margin-left:5px;cursor:pointer'
                  "
                >
                  <i class="el-icon-upload-success el-icon-circle-check"></i>
                </span>
                <span
                  style="position:relative;top:2px;"
                  class="check"
                  :style="
                    item.check
                      ? 'margin-left:5px;cursor:pointer'
                      : 'margin-left:5px;display:none;'
                  "
                >
                  <i class="el-icon-close" @click="deletionPositive(index)"></i>
                </span>
              </span>
            </div>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <!-- 提交部分 -->
    <fixed-footer>
      <el-button
        class="zwx-button zwx-button-28"
        type="primary"
        @click="
          $system.valid(
            $refs['mainForm'],
            '提示',
            '确定要提交吗？',
            '确定',
            '取消',
            commit
          )
        "
        >提交
      </el-button>
    </fixed-footer>
  </div>
</template>

<script>
export default {
  name: "UserEdit",
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      zoneCode12From: undefined,
      userSexCodeTypeCode: this.$route.params.userSexCodeTypeCode,
      userNationCodeTypeCode: this.$route.params.userNationCodeTypeCode,
      educationCodeTypeCode: this.$route.params.educationCodeTypeCode,
      degreeCodeTypeCode: this.$route.params.degreeCodeTypeCode,
      maritalStatusCodeTypeCode: this.$route.params.maritalStatusCodeTypeCode,
      politicalLandscapeCodeTypeCode: this.$route.params
        .politicalLandscapeCodeTypeCode,
      religionCodeTypeCode: this.$route.params.religionCodeTypeCode,
      unitList: [],
      mainForm: {
        fkByUnitId: { rid: "" },
        userNo: "",
        userName: "",
        organIdList: [],
        usedName: "",
        userSex: "",
        userNation: "",
        idc: "",
        mobileTel: "",
        education: "",
        degree: "",
        position: "",
        jobTitle: "",
        maritalStatus: "",
        politicalLandscape: "",
        religion: "",
        ifEnable: true,
        technicalPosition: "",
        major: "",
        workDivision: "",
        fileList: []
      },
      rules: {
        fkByUnitId: {
          rid: [
            {
              required: true,
              message: "请选择机构名称",
              trigger: ["change", "blur"]
            }
          ]
        },
        userNo: [
          {
            required: true,
            message: "请输入用户账号",
            trigger: ["change", "blur"]
          }
        ],
        userName: [
          {
            required: true,
            message: "请输入用户姓名",
            trigger: ["change", "blur"]
          }
        ],
        idc: [
          {
            required: false,
            validator: this.$validate.idcCode,
            trigger: ["change", "blur"]
          }
        ],
        mobileTel: [
          {
            required: false,
            validator: this.$validate.mobilePhone,
            trigger: ["change", "blur"]
          }
        ]
      }
    };
  },
  created() {
    this.zoneCode12From = this.users.ifSuperAdmin
      ? "000000000000"
      : this.users.fkByUnitId.fkByZoneId.zoneCode12;
  },
  mounted() {
    this.detail();
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs;
    }
  },
  methods: {
    detail() {
      this.$emit("loading", true);
      if (this.rid === undefined) {
        this.$refs.areaSelect.initSearch();
        return;
      }
      let data = {
        rid: this.rid
      };
      this.$system.get(
        this.api + "/systematic/getUserInfo-1",
        data,
        true,
        true,
        this.detailSuccess,
        this.detailError
      );
    },
    detailSuccess(data) {
      if (data.type === "00") {
        this.$refs.areaSelect.initSearch(
          data.userInfo.fkByUnitId.fkByZoneId.zoneCode12
        );
        this.mainForm.fkByUnitId.rid = data.userInfo.fkByUnitId.rid;
        this.mainForm.userNo = data.userInfo.userNo;
        this.mainForm.userName = data.userInfo.userName;
        this.setDetailOrganIdList(data.userInfo.organList);
        this.mainForm.usedName = data.userInfo.usedName;
        this.mainForm.userSex = data.userInfo.userSex;
        this.mainForm.userNation = data.userInfo.userNation;
        this.mainForm.idc = this.$zwxSm.sm4JsDecrypt(data.userInfo.idc);
        this.mainForm.mobileTel = this.$zwxSm.sm4JsDecrypt(
          data.userInfo.mobileTel
        );
        this.mainForm.education = data.userInfo.education;
        this.mainForm.degree = data.userInfo.degree;
        this.mainForm.position = data.userInfo.position;
        this.mainForm.jobTitle = data.userInfo.jobTitle;
        this.mainForm.maritalStatus = data.userInfo.maritalStatus;
        this.mainForm.politicalLandscape = data.userInfo.politicalLandscape;
        this.mainForm.religion = data.userInfo.religion;
        this.mainForm.ifEnable = data.userInfo.ifEnable;
        this.mainForm.technicalPosition = data.userInfo.technicalPosition;
        this.mainForm.major = data.userInfo.major;
        this.mainForm.workDivision = data.userInfo.workDivision;
        if (this.$zwxBase.verifyIsNotBlank(data.userInfo.electronicSignature)) {
          this.mainForm.fileList = [
            {
              fileName: data.userInfo.usedName,
              filePath: data.userInfo.electronicSignature
            }
          ];
        }
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
        this.$emit("loading", false);
        this.back();
      }
    },
    detailError() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
      this.back();
    },
    areaSelectLoadOver() {
      this.$emit("loading", false);
    },
    areaSelectChange() {
      this.unitList.splice(0, this.unitList.length);
      this.$refs.userOrganIdRef.setDataList([]);
      let data = {
        areaZoneCode12: this.$refs.areaSelect.getChooseArea().zoneCode12
      };
      this.$system.get(
        this.api + "/systematic/getUnitListByAreaChild-1",
        data,
        true,
        true,
        this.unitListByAreaChildSuccess
      );
    },
    unitListByAreaChildSuccess(data) {
      let hasUnit = false;
      if (data.type === "00") {
        this.unitList = data.unitList;
        for (let i = 0, length = this.unitList.length; i < length; i++) {
          if (this.unitList[i].rid === this.mainForm.fkByUnitId.rid) {
            hasUnit = true;
            break;
          }
        }
      }
      if (hasUnit) {
        this.zoneChangeUnitNoChange();
      } else {
        this.mainForm.fkByUnitId.rid = "";
        this.mainForm.organIdList.splice(0, this.mainForm.organIdList.length);
        this.$refs.userOrganIdRef.setDataList([]);
      }
    },
    unitChange() {
      this.mainForm.organIdList.splice(0, this.mainForm.organIdList.length);
      this.zoneChangeUnitNoChange();
    },
    zoneChangeUnitNoChange() {
      this.$refs.userOrganIdRef.setDataList([]);
      let data = {
        unitId: this.mainForm.fkByUnitId.rid
      };
      this.$system.get(
        this.api + "/systematic/getOrganByUnitIdList-1",
        data,
        true,
        true,
        this.zoneChangeUnitNoChangeSuccess
      );
    },
    zoneChangeUnitNoChangeSuccess(data) {
      if (data.type === "00") {
        this.$refs.userOrganIdRef.setDataList(data.organList);
      }
    },
    commit() {
      this.$emit("loading", true);
      let data = {
        rid: this.rid,
        fkByUnitId: { rid: this.mainForm.fkByUnitId.rid },
        userNo: this.mainForm.userNo,
        userName: this.mainForm.userName,
        organIdList: this.getCommitOrganIdList(),
        usedName: this.mainForm.usedName,
        userSex: this.mainForm.userSex,
        userNation: this.mainForm.userNation,
        idc: this.mainForm.idc,
        mobileTel: this.mainForm.mobileTel,
        education: this.mainForm.education,
        degree: this.mainForm.degree,
        position: this.mainForm.position,
        jobTitle: this.mainForm.jobTitle,
        maritalStatus: this.mainForm.maritalStatus,
        politicalLandscape: this.mainForm.politicalLandscape,
        religion: this.mainForm.religion,
        ifEnable: this.mainForm.ifEnable,
        technicalPosition: this.mainForm.technicalPosition,
        major: this.mainForm.major,
        workDivision: this.mainForm.workDivision,
        electronicSignature: this.mainForm.fileList[0]?.filePath
      };
      this.$system.postJson(
        this.api + "/systematic/addOrModifyUserInfo-1",
        data,
        true,
        true,
        this.commitSuccess,
        this.commitError
      );
    },
    commitSuccess(data) {
      if (data.type === "00") {
        this.$system.notify("成功", data.mess, "success");
        this.$router.replace({
          name: this.breadcrumbs[this.breadcrumbs.length - 2].name,
          params: { fresh: true }
        });
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
        this.$emit("loading", false);
      }
    },
    commitError() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
    },
    back() {
      this.$router.replace({
        name: this.breadcrumbs[this.breadcrumbs.length - 2].name
      });
    },
    setDetailOrganIdList(organList) {
      this.mainForm.organIdList.splice(0, this.mainForm.organIdList.length);
      if (!organList || organList.length === 0) return;
      for (let i = 0, length = organList.length; i < length; i++) {
        this.mainForm.organIdList.push(organList[i].rid);
      }
    },
    getCommitOrganIdList() {
      const dataList = this.$refs.userOrganIdRef.getDataList();
      if (dataList.length === 0) return [];
      const dataRidList = [];
      for (let i = 0, length = dataList.length; i < length; i++) {
        dataRidList.push(dataList[i].rid);
      }
      return dataRidList;
    },
    // 上传
    generateFilesUid() {
      let data = {
        folder: this.folder
      };
      this.$system.get(
        this.api + "/systematic/tools/getAnnexUploadUid-1",
        data,
        true,
        true,
        this.generateSuccess,
        this.generateError
      );
    },
    generateSuccess(data) {
      if (data.type === "00") {
        this.$refs.fileUploadRef.submit(data.annexUploadUid);
      } else {
        this.$emit("loading", false);
        this.$system.notify("错误", data.mess, "error");
      }
    },
    generateError(data) {
      this.$emit("loading", false);
      if (data?.mess) {
        this.$system.notify("错误", data?.mess, "error");
      }
    },
    clickPositive(showList) {
      showList.forEach(item => {
        let flag = this.mainForm.fileList.some(e => e.fileName == item);
        if (flag) {
          return;
        }
        this.mainForm.fileList.push({
          fileName: item,
          fileIconShow: this.$zwxBase.dealfilePrefix(item),
          check: false
        });
      });
      this.generateFilesUid();
    },
    clickPositiveSuccess(fileList) {
      if (
        this.$zwxBase.verifyIsNotBlank(this.mainForm.fileList) &&
        this.$zwxBase.verifyIsNotBlank(fileList)
      ) {
        for (let i in this.mainForm.fileList) {
          for (let j in fileList) {
            if (this.mainForm.fileList[i].fileName === fileList[j].fileName) {
              this.mainForm.fileList[i].filePath = fileList[j].filePath;
              this.mainForm.fileList[i].fileType = 1;
            }
          }
        }
        this.$emit("getFileList", this.mainForm.fileList);
      }
    },
    clickError() {},
    mouseenter(index) {
      this.mainForm.fileList[index].check = true;
      this.$forceUpdate();
    },
    mouseleave(index) {
      this.mainForm.fileList[index].check = false;
      this.$forceUpdate();
    },
    // 删除文件
    deletionPositive(index) {
      let fileName = this.mainForm.fileList[index].fileName;
      let filePath = this.mainForm.fileList[index].filePath;
      this.mainForm.fileList.splice(index, 1);
      if (this.$zwxBase.verifyIsBlank(filePath)) {
        this.$refs.fileUploadRef.deleteIndex(index);
      }
      let fileList = this.$refs.fileUploadRef.showFileList || [];
      let count = 0;
      fileList.forEach(item => {
        if (fileName === item) {
          count++;
        }
      });
      for (let i = 0; i < count; i++) {
        for (let j in fileList) {
          if (fileName === fileList[j]) {
            this.$refs.fileUploadRef.deleteIndex(j);
            fileList = this.$refs.fileUploadRef.showFileList || [];
            continue;
          }
        }
      }
      this.$emit("getFileList", this.mainForm.fileList);
    },
    openFilePreview(fileList, index) {
      let previewFileList = [];
      if (!this.$zwxBase.verifyIsBlank(fileList)) {
        fileList.forEach(file => {
          let item = {
            fileName: file.fileName,
            filePath: file.filePath
          };
          previewFileList.push(item);
        });
        this.$nextTick(function() {
          top.postMessage(
            {
              handlerType: "previewFile",
              params: {
                fileList: previewFileList,
                index
              }
            },
            "*"
          );
        });
      }
    }
  }
};
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
